import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Notifications from 'vue-notification'
import VueLodash from 'vue-lodash'
import VTooltip from 'v-tooltip'

Vue.config.productionTip = false;
const options = { name: 'lodash' };

Vue.use(Notifications);
Vue.use(VueLodash, options);
Vue.use(VTooltip);

import './styles/_tooltip.sass';

new Vue({
  router,
  render: h => h(App)
}).$mount('#app');
